"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
const circle_1 = require("./circle");
const rectangle_1 = require("./rectangle");
/**
 * Кнопки действий
 *
 * Circle - Круглая кнопка действия
 * Rectangle - Прямоугольная кнопка действия
 *
 * @see https://www.figma.com/file/OiFlIdSpmFYZ5zsFGWA3TD/%F0%9F%9B%A0Web-%3A%3A-Click-Components?node-id=90253%3A452996
 */
exports.ActionButton = {
    Circle: circle_1.Circle,
    Rectangle: rectangle_1.Rectangle,
};
